import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import SpinButton from 'components/Buttons/SpinButton';
import PropTypes from 'prop-types';
import React from 'react';

const Component = props => {
  const { bodyHeight, children } = props;

  return (
    <Grid sx={{ justifyContent: 'center', alignItems: 'center' }} container style={{ height: bodyHeight }}>
      <Grid size={5} style={{ height: '50%' }}>
        <Box display="flex" justifyContent="center" alignItems="center">
          {children}
        </Box>
        <Box display="flex" justifyContent="center" alignItems="center">
          <div style={{ margin: 15 }}>
            <SpinButton {...props}/>
          </div>
        </Box>
      </Grid>
    </Grid>
  );
};

export default Component;

Component.propTypes = {
  bodyHeight: PropTypes.number.isRequired,
  children: PropTypes.element.isRequired
};
